import {isSet,isEmpty,source} from './utils/common'
export function repaymentCalc(){
	if(validateRepaymentForm()){
		document.getElementById('spinner').classList.remove('hidden');
		//ajax
		$.ajax({
            url: "/homes/re2/homeloanRepaymentCalc?aj=1",
            type: "POST",
            data: {'homeloanRepaymentCalc' : JSON.stringify(homeloancalc.mrepaymentCalc)},
            success: function (data) {
                if(!isEmpty(data)){
                	document.getElementById('spinner').classList.add('hidden');
                	document.getElementById('hl_monthluy_repayment_response').classList.remove('opacity_otp');
                	document.getElementById('repayment_principal_paid').innerHTML = '&#8377; ' + data['principalPaid'];
                    document.getElementById('repayment_principal_outstndg').innerHTML = '&#8377; ' + data['principalOutstanding'];
                    document.getElementById('repayment_interest_paid').innerHTML = '&#8377; ' + data['interestPaid'];
                    document.getElementById('repayment_interest_outstndg').innerHTML = '&#8377; ' + data['interestOutstanding'];
                    document.getElementById('repayment_intallments_paid').innerHTML = data['numberEmiPaid'];
                    document.getElementById('repayment_emi').innerHTML = '&#8377; ' + data['emi'];
                }else{
                	document.getElementById('spinner').classList.add('hidden');
                    document.getElementById('error_message').innerHTML = 'Request not found. Please try again by changing values.';
                    document.getElementById('hc_error_popup').click();
                    return false;
                }
            } 
        });
	}else {
		return false;
	}
}

export function resetRepaymentForm(){
	document.getElementById('mRepayment_loan_amount').value = '';
	document.getElementById('mRepayment_loan_tenure_year').value = '';
	document.getElementById('mRepayment_loan_tenure_month').value = '';
	document.getElementById('mRepayment_installments_paid').value = '';
	document.getElementById('mRepayment_loan_amount_price').innerHTML = '';
	document.getElementById('mRepayment_rate_of_interest_price').innerHTML = '';
	document.getElementById('mRepayment_rate_of_interest').value = '';
	document.getElementById('mRepayment_installments_paid_price').innerHTML = '';
	document.getElementById('hl_monthluy_repayment_response').classList.add('opacity_otp');
	document.getElementById('repayment_principal_paid').innerHTML = '&#8377; 00.00';
    document.getElementById('repayment_principal_outstndg').innerHTML = '&#8377; 00.00';
    document.getElementById('repayment_interest_paid').innerHTML = '&#8377; 00.00';
    document.getElementById('repayment_interest_outstndg').innerHTML = '&#8377; 00.00';
    document.getElementById('repayment_intallments_paid').innerHTML = '&#8377; 00.00';
    document.getElementById('repayment_emi').innerHTML = '&#8377; 00.00';
}

function validateRepaymentForm(){
	let isEmiFormValid = false;
	//Repayment loan amount check..
	if(isRePaymentLoanAmountValid()) {
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//Repayment loan tenure year and month check
	if(isRePaymentLoanTenureValid()){
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//Repayment rate of interest check
	if(isRePaymentRateOfInterestValid()){
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//Repayment installments check
	if(isRePaymentInstallmentsValid()) {
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	return isEmiFormValid;
}

function isRePaymentLoanAmountValid() {
	let mRepayment_loan_amount = document.getElementById('mRepayment_loan_amount').value;
	let regex = /^[0-9, ]+$/i;
	if(mRepayment_loan_amount.match(regex) && mRepayment_loan_amount !='') {
		HomeLoanCalculator.hideError('mRepayment_loan_amount_error');
		homeloancalc.mrepaymentCalc.mRepayment_loan_amount = mRepayment_loan_amount.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid loan amount";
		HomeLoanCalculator.showError('mRepayment_loan_amount_error', msg);
		return false;
	}
}

export function isRePaymentLoanTenureValid() {
	let tenure_year = document.getElementById('mRepayment_loan_tenure_year').value;
	let tenure_month = document.getElementById('mRepayment_loan_tenure_month').value;
	if(tenure_year == '' && tenure_month == ''){
		let msg = "Enter valid loan tenure years or months";
		HomeLoanCalculator.showError('mRepayment_loan_tenure_error', msg);
		return false;
	}else if(tenure_year != '' && tenure_month == ''){
		isRepaymentLoanTenureYearValid(tenure_year);
	}else if(tenure_month != '' && tenure_year == ''){
		isRepaymentLoanTenureMonthValid(tenure_month);
	}else {
		let YearTenure = isRepaymentLoanTenureYearValid(tenure_year);
		let MonthTenure = isRepaymentLoanTenureMonthValid(tenure_month);
		if(YearTenure && MonthTenure){
			HomeLoanCalculator.hideError('mRepayment_loan_tenure_error');
			return true;
		}else if(!YearTenure){
			let msg = "Enter valid loan tenure years";
			HomeLoanCalculator.showError('mRepayment_loan_tenure_error', msg);
		}else if(!MonthTenure){
			let msg = "Enter valid loan tenure months";
			HomeLoanCalculator.showError('mRepayment_loan_tenure_error', msg);
		}
	}
		
}

function isRepaymentLoanTenureYearValid(tenure_year) {
	let regex = /^[0-9, ]+$/i;
	if(tenure_year.match(regex) && tenure_year !='') {
		HomeLoanCalculator.hideError('mRepayment_loan_tenure_error');
		homeloancalc.mrepaymentCalc.tenure_year = tenure_year.replace(/,/g, '');
		return true;
	} else {
		document.getElementById('mRepayment_loan_tenure_year').value = '';
		let msg = "Enter valid loan tenure years";
		HomeLoanCalculator.showError('mRepayment_loan_tenure_error', msg);
		return false;
	}
}

function isRepaymentLoanTenureMonthValid(tenure_month) {
	let regex = /^[0-9 ]+$/i;
	if(tenure_month !='' && tenure_month.match(regex) && tenure_month >= 0 && tenure_month < 12) {
		HomeLoanCalculator.hideError('mRepayment_loan_tenure_error');
		homeloancalc.mrepaymentCalc.tenure_month = tenure_month;
		return true;
	} else {
		document.getElementById('mRepayment_loan_tenure_month').value = '';
		let msg = "Enter valid loan tenure months";
		HomeLoanCalculator.showError('mRepayment_loan_tenure_error', msg);
		return false;
	}
}

function isRePaymentInstallmentsValid() {
	let mRepayment_installments_paid = document.getElementById('mRepayment_installments_paid').value;
	let regex = /^[0-9]+$/i;
	if(mRepayment_installments_paid.match(regex) && mRepayment_installments_paid !='') {
		HomeLoanCalculator.hideError('mRepayment_installments_paid_error');
		homeloancalc.mrepaymentCalc.mRepayment_installments_paid = mRepayment_installments_paid.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid installments paid";
		HomeLoanCalculator.showError('mRepayment_installments_paid_error', msg);
		return false;
	}
}

function isRePaymentRateOfInterestValid() {
	let mRepayment_rate_of_interest = document.getElementById('mRepayment_rate_of_interest').value;
	let regex = /^[0-9. ]+$/i;
	if(mRepayment_rate_of_interest.match(regex) && mRepayment_rate_of_interest !='') {
		HomeLoanCalculator.hideError('mRepayment_rate_of_interest_error');
		homeloancalc.mrepaymentCalc.mRepayment_rate_of_interest = mRepayment_rate_of_interest.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid rate of interest";
		HomeLoanCalculator.showError('mRepayment_rate_of_interest_error', msg);
		return false;
	}
}


